/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Dropdown,
  Modal,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  EditOutlined,
  DeleteOutlined,
  OneToOneOutlined,
  MenuOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import moment from "moment";
import AddModal from "./component/AddModal";

export default function TypeJob() {
  const addModalRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const childRef = useRef();
  const [tableLoading, setTableLoading] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // table
  const initTableHead = {
    bankGroup: null,
    remark: null,
    createByName: null,
    updateByName: null,
    active: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("Edit") ||
          commonFn.btnAuthorityFlag("Delete")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("Edit") && {
                  key: "edit",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Edit </div>,
                },
                commonFn.btnAuthorityFlag("Delete") && {
                  key: "delete",
                  icon: (
                    <DeleteOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete </div>,
                },
              ].filter(Boolean),
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "BankGroup",
      dataIndex: "bankGroup",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "bankGroup"),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "remark"),
    },
    {
      title: "Active",
      dataIndex: "active",
      titleType: "Select",
      width: 80,
      selectOptions: [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
      ],
      onChange: (value) => tableFilterFn(value, "active", "Select"),
      render: (value) => (value === 1 ? "Active" : "Inactive"),
    },
    {
      title: "Create By Name",
      dataIndex: "createByName",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "createByName"),
    },
    {
      title: "Create Time",
      dataIndex: "createTime",
      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY ") : " ",
    },
    {
      title: "Update By Name",
      dataIndex: "updateByName",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "updateByName"),
    },

    {
      title: "Update Time",
      dataIndex: "updateTime",
      key: "updateTime",

      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY ") : " ",
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 调用子组件showModal方法
  const showModalAdd = () => {
    addModalRef.current?.setModelAdd();
  };

  const showModalThree = () => {
    if (
      childRef.current &&
      typeof childRef.current.clearInputs === "function"
    ) {
      childRef.current.clearInputs();
      childRef.current.newListFun();
    }
  };

  const handleMenuClick = async (e, record) => {
    if (e.key === "edit") {
      addModalRef.current?.setModelEdit(record);
    }
    if (e.key === "delete") {
      Modal.confirm({
        className: "commonModal",
        title: "Complete Request",
        icon: <ExclamationCircleOutlined />,
        content: <span>Are you sure to delete this data?</span>,
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          setLoading(true);
          try {
            const params = { id: record.id };
            const response = await http.get(api.getBankByGroupDelete, {
              params,
            });
            if (response.code === "1") {
              message.success("Successfully deleted.");
              getTableListFn(
                pagination.current,
                pagination.pageSize,
                tableHead,
              );
            } else {
              message.error(response?.msg || "Delete failed.");
            }
          } catch (error) {
            message.error("An error occurred. Please try again.");
          } finally {
            setLoading(false);
          }
        },
        onCancel() {},
        style: {
          top: "40%",
        },
      });
    }
  };

  // 处理选项变化
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };

  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  // 获取列表数据
  const getTableListFn = async (current, pageSize, searchParams = {}) => {
    setTableLoading(true);
    try {
      const queryParams = {
        page: current || pagination.current,
        count: pageSize || pagination.pageSize,
        ...searchParams,
      };

      Object.keys(queryParams).forEach((key) => {
        if (
          queryParams[key] === null ||
          queryParams[key] === undefined ||
          queryParams[key] === ""
        ) {
          delete queryParams[key];
        }
      });

      const response = await http.get(api.getBankByGroupShow, {
        params: queryParams,
      });

      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        setTableLoading(false);
        return;
      }

      const data = response.data || {};
      const list = (data.list || []).map((item) => ({
        ...item,
        key: item.id,
      }));
      setTableList(list);

      setPagination({
        current: data.pageNum || current || 1,
        pageSize: data.pageSize || pageSize || 25,
        total: data.total || 0,
      });
    } catch (error) {
      message.error("Failed to fetch data");
    } finally {
      setTableLoading(false);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
              <Button className="btnNew" onClick={showModalAdd}>
                <PlusOutlined />
                New
              </Button>
            </Space>
          )) ||
            null}
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="id"
      />

      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
    </div>
  );
}
